module.exports = __webpack_public_path__ + "static/media/icon-vimeo.c5b43b7f.svg";